import Vue from 'vue';
import store from '@/store';
import router from '@/router';
import axios from 'axios';
import VueAxios from 'vue-axios';
import {nanoid} from "nanoid";
const camelcaseObjectDeep = require('camelcase-object-deep');

Vue.use(VueAxios, axios);

export const $http = axios.create({
  baseURL: process.env.VUE_APP_ROOT_API,
  headers: {
    'Authorization': `Bearer ${localStorage.getItem('user_token')}`,
    'Accept': 'application/json',
  }
});
$http.interceptors.request.use((config) => {
  const cart_id = localStorage.getItem('cart_id') ? localStorage.getItem('cart_id') : localStorage.setItem('cart_id', nanoid())
  config.headers['Authorization'] = `Bearer ${localStorage.getItem('user_token')}`;
  config.headers['X-localization'] = store.getters.currentLanguage.translationKey;
  config.headers['X-currency'] = `${localStorage.getItem('currency')}`;
  config.headers['Cart-id'] = `${cart_id}`;
  return config;
});
$http.interceptors.response.use((response) => {
    response.data = camelcaseObjectDeep(response.data);
    return response;
  }, (error) => {
    switch (error.response.status) {
      case 500: {
        router.push({name: 'server-not-found'}).catch(() => {console.log()});
        break;
      }
      case 404: {
        router.push({name: 'page-not'}).catch(() => {console.log()});
        break;
      }
      case 401: {
        router.push({name: 'sing-in'}).catch(() => {console.log()});
        store.commit('auth/REMOVE_TOKEN');
        break;
      }
      default: {
        break;
      }
    }
  return Promise.reject(camelcaseObjectDeep(error.response));
  }
);

export default function install(Vue) {
  Object.defineProperty(Vue.prototype, '$http', {
    get() {
      return $http
    }
  })
}
